import React from "react";
import { ModalBuilder, Modal, Form } from "@redriver/cinnamon";
import { editCustomerContact } from "./actions";
import CustomerContactForm from "./CustomerContactForm";

const EditCustomerContact = ({
  modalOpen,
  closeModal,
  onRefresh,
  contact,
  customerId,
  customerType,
}) => (
  <ModalBuilder
    withForm
    visible={modalOpen}
    submitAction={editCustomerContact}
    submitParams={{ customerId, contactId: contact.id }}
    onSubmitted={() => {
      closeModal();
      onRefresh();
    }}
    onCancel={closeModal}
    initialData={contact}
    renderModal={(modalProps, formProps) => (
      <Modal.Edit {...modalProps} header="Edit Contact">
        <Form {...formProps}>
          <CustomerContactForm
            customerType={customerType}
            titleText={contact.title}
            lockPrimary={contact.isMain}
          />
        </Form>
      </Modal.Edit>
    )}
  />
);

export default EditCustomerContact;
